import { cn } from "@humanex/ui/libs";
import * as React from "react";

export interface ISpinner extends React.InputHTMLAttributes<HTMLDivElement> {
  label?: string;
}

const Spinner = React.forwardRef<HTMLInputElement, ISpinner>(({ className, label, ...props }, ref) => {
  return (
    <div ref={ref} {...props}>
      <div className={cn("relative flex w-8 h-8", className)}>
        <i className="absolute w-full h-full rounded-full border-3 border-b-primary animate-spin border-solid border-t-transparent border-l-transparent border-r-transparent"></i>
      </div>
      {label && <div>{label}</div>}
    </div>
  );
});
Spinner.displayName = "Spinner";

export { Spinner };
